export { defaultWagmiConfig } from '@web3modal/base/adapters/evm/wagmi';
//# sourceMappingURL=config.js.map